module.exports = __webpack_public_path__ + "img/household-chemicals.f3e628d5.png";